
import Radio from '@mui/material/Radio';
import FormControlLabel from '@mui/material/FormControlLabel';

const RadioButton = ({ checked, onChange, value, label }) => {
  return (
    <FormControlLabel
      control={<Radio checked={checked} onChange={onChange} value={value} />}
      label={label}
    />
  );
};

export default RadioButton;
